import { getLocale } from '@gamiphy/utils/locale';
import { FormatterOptions } from './types';

declare global {
  interface Window {
    GAMIPHY_CURRENCY_CODE?: string,
  }
}

export const round = (number: number, precision = 0): number => {
  const normalizedPrecision = precision >= 0 ? Math.min(precision, 292) : Math.max(precision, -292);
  if (normalizedPrecision) {
    // Shift with exponential notation to avoid floating-point issues.
    // See [MDN](https://mdn.io/round#Examples) for more details.
    let pair = `${number}e`.split('e');
    const value = Math.round(Number(`${pair[0]}e${+pair[1] + normalizedPrecision}`));

    pair = `${value}e`.split('e');
    return +`${pair[0]}e${+pair[1] - normalizedPrecision}`;
  }
  return Math.round(number);
};

/**
 * Format number to string
 * @param n
 * @param options
 */
export const formatNumber = (n: number, options?: FormatterOptions): string => Intl.NumberFormat(getLocale(), {
  notation: options?.notation ?? 'compact',
  compactDisplay: options?.compactDisplay ?? 'short',
  minimumFractionDigits: options?.minimumFractionDigits ?? 0,
  maximumFractionDigits: options?.maximumFractionDigits ?? 3,
}).format(n);

/**
 * Format number to string with currency style
 * @param n
 * @param options
 */
export const formatCurrencyNumber = (n: number, options?: FormatterOptions): string => new Intl.NumberFormat(getLocale(), {
  style: 'currency',
  currency: options?.currency ?? window.GAMIPHY_CURRENCY_CODE ?? 'usd',
  notation: options?.notation ?? 'compact',
  minimumFractionDigits: options?.minimumFractionDigits ?? 2,
  maximumFractionDigits: options?.maximumFractionDigits ?? 2,
}).format(n);
